// 实训中心
import {
  blocklyEditor01,
  blocklyEditor02,
  blocklyEditor03,
  blocklyEditor04,
  blocklyEditor05,
} from '@/utils/images.js'

const primaryGuide = [
  {
    id: 'guide-1',
    rightnavs: 'AI-T编辑器',
    title: '第1步，拖拽拼搭功能积木',
    content: '',
    note: '',
    level: 1,
    children: [
      {
        id: 'guide-1-1',
        level: 2,
        content:
          '从左侧积木分类区将需要的基础功能积木拖拽至编程区，按照逻辑对进行积木拼搭。',
        note: '',
        imgUrlList: [],
        videoUrlList: [
          {
            url: blocklyEditor01,
            label: '',
          },
        ],
      },
    ],
  },
  {
    id: 'guide-2',
    level: 1,
    title: '第2步，上传媒体文件',
    content: '',
    note: '',
    children: [
      {
        id: 'guide-2-1',
        level: 2,
        content:
          '在积木分类区，点击“媒体”，选择上传图片文件，系统将对上传的图片自动转化为积木块；将系统生成的图片积木拼搭在程序中。',
        note: '',
        imgUrlList: [],
        videoUrlList: [
          {
            url: blocklyEditor02,
            label: '',
          },
        ],
      },
    ],
  },
  {
    id: 'guide-3',
    level: 1,
    title: '第3步，调用算法模型积木',
    content: '',
    note: '',
    children: [
      {
        id: 'guide-3-1',
        level: 2,
        content: '调用算法模型积木，完善项目程序。',
        note: '',
        imgUrlList: [],
        videoUrlList: [
          {
            url: blocklyEditor03,
            label: '',
          },
        ],
      },
    ],
  },
  {
    id: 'guide-4',
    level: 1,
    title: '第4步，查看项目代码',
    content: '',
    note: '',
    children: [
      {
        id: 'guide-4-1',
        level: 2,
        content: '点击菜单栏中“查看代码”按钮，可查看当前积木编程的对应代码段。',
        note: '',
        imgUrlList: [],
        videoUrlList: [
          {
            url: blocklyEditor04,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    id: 'guide-5',
    level: 1,
    title: '第5步，运行程序结果展示',
    content: '',
    note: '',
    children: [
      {
        id: 'guide-5-1',
        level: 2,
        content:
          '完成项目编写后，点击“运行”按钮，运行项目程序；在终端区和绘图区输出和展示运行结果。',
        note: '',
        imgUrlList: [],
        videoUrlList: [
          {
            url: blocklyEditor05,
            label: '',
            display: '',
          },
        ],
      },
    ],
  },
  {
    level: 1,
    footer:
      '更多关于AI-T编辑器（积木模式）的学习使用，可查看“使用文档”详情内容哦！现在，快快去创作吧~',
  },
]

//附件
const secodeGuide = []
export default {
  primaryGuide,
  secodeGuide,
}
